import * as React from 'react';
export const blikSvg = React.forwardRef(function blikSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.058 5.887c-.866 0-1.68.218-2.392.6V.766H3v10.176a5.058 5.058 0 0 0 10.115 0 5.056 5.056 0 0 0-5.057-5.055Zm0 7.49a2.435 2.435 0 1 1 0-4.869 2.435 2.435 0 0 1 0 4.869Zm2.672-8.606a2.386 2.386 0 1 0 0-4.771 2.386 2.386 0 0 0 0 4.771Z',
    }),
  );
});
blikSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var blik = {
  category: 'paymentmethod',
  colorable: true,
  name: 'blik',
  svg: blikSvg,
};
